import { makeCSSVar, readCSSVar } from 'lib/theme/themeUtils'

export const themeLayoutCSSVariables: App.Design.Layout<App.Design.CSSVar> = {
  topScrollOffset: makeCSSVar('app', 'top', 'scroll', 'offset'),
  headerFloatingOffset: makeCSSVar('app', 'header', 'floating', 'offset'),
  headerRelativeOffset: makeCSSVar('app', 'header', 'relative', 'offset'),
  footerFloatingOffset: makeCSSVar('app', 'footer', 'floating', 'offset'),
  footerRelativeOffset: makeCSSVar('app', 'footer', 'relative', 'offset'),
}

const themeLayout: App.Design.Layout<App.Design.CSSVarValue> = {
  topScrollOffset: readCSSVar(themeLayoutCSSVariables.topScrollOffset),
  headerFloatingOffset: readCSSVar(themeLayoutCSSVariables.headerFloatingOffset),
  headerRelativeOffset: readCSSVar(themeLayoutCSSVariables.headerRelativeOffset),
  footerFloatingOffset: readCSSVar(themeLayoutCSSVariables.footerFloatingOffset),
  footerRelativeOffset: readCSSVar(themeLayoutCSSVariables.footerRelativeOffset),
}

export default themeLayout
